<!-- <template>
  <div class="account-login-contaienr">
    <div class="account-login-bd">
      <div class="company-info-container">
        <div class="title">
          <span>绑定手机号</span>
        </div>
      </div>
      <div class="account-login-mainer">
        <div class="login-form-container">
          <div class="login-form-phone">
            <el-form
              :model="smsFrom"
              status-icon
              :rules="smsRules"
              ref="smsFrom"
            >
              <el-form-item prop="phone">
                <el-input
                  type="number"
                  prefix-icon="el-icon-mobile-phone"
                  placeholder="请输手机号"
                  v-model="smsFrom.phone"
                  autocomplete="off"
                >
                  <el-select
                    slot="prepend"
                    v-model="countryCode"
                    style="width: 100px"
                    class="country-code"
                  >
                    <el-option
                      v-for="(item, i) in geo"
                      :key="i"
                      :label="item.value"
                      :value="item.value"
                    >
                      <span style="float: left; font-size: 13px">{{
                        item.name
                      }}</span>
                      <span
                        style="
                          float: right;
                          margin-left: 50px;
                          color: #8492a6;
                          font-size: 13px;
                        "
                        >{{ item.value }}</span
                      >
                    </el-option>
                  </el-select>
                </el-input>
              </el-form-item>
              <el-form-item prop="code">
                <div class="flex-cell">
                  <el-input
                    class="flex-cell-bd"
                    type="number"
                    placeholder="请输入验证码"
                    v-model="smsFrom.code"
                    autocomplete="off"
                    prefix-icon="el-icon-mobile"
                  ></el-input>
                  <el-button
                    :disabled="disabled"
                    class="flex-cell-ft"
                    @click="handleSendCode"
                    >{{ buttonName }}
                  </el-button>
                </div>
              </el-form-item>
              <el-form-item>
                <el-button
                  :btnLoading="btnLoading"
                  :disabled="btnLoading"
                  type="primary"
                  style="width: 100%"
                  @click="submitForm('smsFrom')"
                  >绑定手机
                </el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template> -->
<template>
  <div class="page-container">
    <div class="page-content">
      <img class="page-content-left" src="../assets/images/bitmap.png" />
      <div class="page-content-right">
        <div class="content-right-title">绑定手机号</div>
        <el-form :model="smsFrom" status-icon :rules="smsRules" ref="smsFrom">
          <el-form-item prop="phone">
            <el-input
              style="height: 40px"
              placeholder="手机号"
              prefix-icon="mobile"
              v-model="smsFrom.phone"
            >
              <i slot="prefix">
                <img src="../assets/images/mobile.svg" class="input-icon"
              /></i>
            </el-input>
          </el-form-item>
          <el-form-item prop="code">
            <div class="flex-cell">
              <el-input
                type="number"
                v-model="smsFrom.code"
                autocomplete="off"
                placeholder="验证码"
                class="flex-cell-in"
              >
                <i slot="prefix" class="el-input__icon">
                  <img src="../assets/images/mail.svg" class="input-icon" /> </i
              ></el-input>
              <el-button
                size="small"
                :disabled="disabled"
                class="flex-cell-ft"
                @click="handleVerify"
                >{{ buttonName }}</el-button
              >
            </div>
          </el-form-item>
          <div
            size="small"
            v-loading="btnLoading"
            :disabled="btnLoading"
            @click="submitForm('smsFrom')"
            class="login-btn"
          >
            绑 定
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "@/global/request/axios";
import API from "@/global/request/api";
import { getQuery } from "@/utils/tool";
import geo from "@/utils/geo";

export default {
  data() {
    return {
      referer: getQuery("referer"),
      btnLoading: false,
      countryCode: "+86",
      geo: geo,
      passwordFrom: {
        phone: "",
        password: "",
        checked: true,
      },
      smsFrom: {
        phone: "",
        code: "",
        checked: true,
      },
      smsRules: {
        phone: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
          {
            pattern: /^\d+$/,
            message: "手机号只能为数字",
            trigger: "blur",
          },
          {
            pattern:
              /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
            message: "手机号码格式不支持",
            trigger: "blur",
          },
        ],
        code: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "blur",
          },
        ],
      },
      passwordRules: {
        phone: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
          {
            pattern: /^\d+$/,
            message: "手机号只能为数字",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
        ],
      },
      buttonName: "获取验证码",
      disabled: false,
      source: null,
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (formName === "smsFrom") {
            if (this.smsFrom.code.length != 6) {
              this.$message.error("验证码不符合要求");
            }
            this.btnLoading = true;
            if (this.$route.query.source) {
              this.source = this.$route.query.source;
            }
            axios
              .post(
                API.phoneBind,
                {
                  phone_number: `${this.countryCode} ${this.smsFrom.phone}`,
                  code: this.smsFrom.code,
                  state: getQuery("state"),
                  source: this.source,
                },
                { withCredentials: true }
              )
              .then(() => {
                window.location.href = this.referer
                  ? this.referer
                  : "https://www." +
                    document.domain.split(".").slice(-2).join(".");
              })
              .catch(() => {
                this.btnLoading = false;
              })
              .finally(() => {
                this.btnLoading = false;
              });
          }
        }
      });
    },
    handleVerify() {
      this.$refs.smsFrom.validateField("phone", (errMsg) => {
        if (errMsg) return;
        if (process.env.NODE_ENV !== "development") {
          // eslint-disable-next-line
          var captcha = new TencentCaptcha(
            "2092849777",
            this.handleSendCode,
            {}
          );
          captcha.show();
        } else {
          this.handleSendCode();
        }
      });
    },
    handleSendCode(res) {
      if (this.disabled) {
        return;
      }

      this.$refs.smsFrom.validateField("phone", (errMsg) => {
        if (errMsg) return;
        this.disabled = true;
        axios
          .post(
            API.phoneCode,
            {},
            {
              params: {
                phone_number: `${this.countryCode} ${this.smsFrom.phone}`,
                randstr: res ? res.randstr : "123456",
                ticket: res ? res.ticket : "123456",
              },
            }
          )
          .then((res) => {
            this.countDown();
            if (process.env.VUE_APP_AUTO_CODE === "true")
              this.smsFrom.code = res.code;
          })
          .catch(() => {
            this.disabled = false;
          });
      });
    },
    countDown() {
      let time = 60;
      this.buttonName = `(${time})秒重新发送`;
      const interval = window.setInterval(() => {
        time -= 1;
        this.buttonName = `(${time})秒重新发送`;
        if (time <= 0) {
          this.buttonName = "重新发送";
          this.disabled = false;
          window.clearInterval(interval);
        }
      }, 1000);
    },
  },
};
</script>

<style lang="less" scoped>
.page-container {
  height: 100vh;
  width: 100%;
  background-color: rgba(240, 242, 245, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  .page-content {
    display: flex;
    align-items: center;
    .page-content-left {
      height: 460px;
      width: 264px;
      object-fit: cover;
    }
    .page-content-right {
      width: 480px;
      height: 460px;
      background: white;
      border-radius: 0px 4px 4px 0px;
      padding: 120px 92px;
      text-align: center;
      /deep/.el-input.is-active .el-input__inner,
      /deep/.el-input__inner:focus {
        border-color: rgba(15, 199, 0, 1);
      }
      /deep/.el-input--prefix .el-input__inner {
        padding-left: 34px;
      }
      .content-right-title {
        height: 28px;
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
        line-height: 28px;
        margin-bottom: 24px;
      }
    }
  }
}
.input-icon {
  object-fit: cover;
  width: 16px;
  height: 16px;
  margin-top: 12px;
  margin-left: 6px;
}
.login-btn {
  margin-top: 24px;
  width: 296px;
  height: 40px;
  background: #0fc700;
  border-radius: 2px;
  line-height: 40px;
  text-align: center;
  color: white;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  &:hover {
    background: rgba(15, 199, 0, 0.85);
  }
}
.title {
  text-align: center;
  margin: 20px auto;
}
.title span {
  font-size: 200%;
}
.flex-cell {
  display: flex;
  align-items: center;
  .flex-cell-ft {
    width: 114px;
    height: 40px;
  }
  .flex-cell-in {
    width: 186px;
    height: 40px;
    margin-right: 8px;
  }
  /deep/.el-button:focus,
  .el-button:hover {
    color: rgba(15, 199, 0, 1) !important;
    border-color: rgba(15, 199, 0, 0.1);
    background-color: rgba(15, 199, 0, 0.01);
  }
}
</style>
